export default __webpack_public_path__ + "static/media/klienci.58c6552b.png";